// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionPresentationProps } from "@conklin/MobiusOverrides/AccordionSection/AccordionSection";
import { xParserOptions } from "@conklin/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";
import { TypographyProps } from "@insite/mobius/Typography";
import parse from "html-react-parser";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    fields: {
        expanded: boolean;
    };
}

type Props = OwnProps & HasProduct;

export interface ProductDetailsHighlightsStyles {
    accordionSection?: AccordionSectionPresentationProps;
    productHighlights?: TypographyProps;
}

export const productHighlightsStyles: ProductDetailsHighlightsStyles = {
    productHighlights: {
        css: css`
            & li {
                margin-left: 16px;
            }
        `,
    },
};

const styles = productHighlightsStyles;

const ProductDetailsHighlights: React.FC<Props> = ({ product, fields }) => {
    if (!product?.properties?.productHighlights) {
        return null;
    }

    return (
        <ManagedAccordionSection
            title={translate("Highlights")}
            data-test-selector="productDetails_productHighlights"
            initialExpanded={fields.expanded}
            {...styles.accordionSection}
        >
            <StyledWrapper {...styles.productHighlights}>
                {parse(transformContentHtml(product.properties.productHighlights), xParserOptions)}
            </StyledWrapper>
        </ManagedAccordionSection>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsHighlights),
    definition: {
        displayName: "Product Highlights",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: "expanded",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
